<template lang="pug">
div
  .empty.my-2(v-if='!current.socios || !current.socios.length')
    .empty-icon
      i.fa.fa-users.fa-5x
    .empty-subtitle Nenhum sócio encontrado
  table.table.table-responsive.table.table-sm(v-else)
    thead
      tr
        th {{ 'cgcm.cpf_cnpj' | tModel }}
        th {{ 'cgcm.razao_social' | tModel }}
        th {{ 'socio.vinculo' | tModel }}
        th {{ 'socio.principal' | tModel }}
        th {{ 'socio.percentual' | tModel }}
    tbody
      tr(v-for='socio in current.socios')
        td {{ socio.cgcm.cpf_cnpj | cpfCnpj }}
        td {{ socio.cgcm.razao_social }}
        td {{ socio.vinculo || '-' }}
        td {{ socio.principal ? 'Sim' : 'Não' }}
        td {{ socio.percentual | currency('', '%') }}
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/show'

export default {
  vuex: { cadastros: vuexDefaultMapping },
}
</script>
